import React from 'react'

function EcoFarming() {
  return (
    <div>
       <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Eco Farming</h1>
      <p><strong>Last updated: 22 April 2025</strong></p>

      <p>
        Eco farming, also known as ecological farming, is a sustainable method of farming that promotes environmental health and conserves resources. It involves practices that protect the ecosystem, reduce pollution, and ensure that farming operations are in harmony with nature.
      </p>

      <h3>1. What is Eco Farming?</h3>
      <p>Eco farming is a holistic approach to farming that focuses on environmental sustainability. It includes techniques such as crop rotation, organic farming, water conservation, and soil health maintenance. Eco farming aims to reduce the environmental footprint while ensuring productivity and quality.</p>

      <h3>2. Benefits of Eco Farming</h3>
      <p>Eco farming offers several environmental, economic, and social benefits:</p>
      <ul>
        <li><strong>Soil Conservation:</strong> Eco farming practices help maintain soil fertility and prevent erosion.</li>
        <li><strong>Water Conservation:</strong> Eco-friendly methods ensure efficient water use, reducing wastage and promoting sustainability.</li>
        <li><strong>Biodiversity Protection:</strong> Eco farming preserves local wildlife, promotes biodiversity, and prevents the destruction of natural habitats.</li>
        <li><strong>Healthier Produce:</strong> By avoiding chemical pesticides and fertilizers, eco farming produces healthier and more nutritious crops.</li>
      </ul>

      <h3>3. Key Eco Farming Techniques</h3>
      <p>Some of the most effective eco farming techniques include:</p>
      <ul>
        <li><strong>Organic Farming:</strong> Avoiding synthetic chemicals and using natural methods to improve soil and crop health.</li>
        <li><strong>Crop Rotation:</strong> Rotating crops helps prevent soil depletion and control pests naturally.</li>
        <li><strong>Composting:</strong> Using organic waste to create nutrient-rich soil for sustainable farming.</li>
        <li><strong>Water Management:</strong> Eco farmers use efficient irrigation techniques like drip irrigation and rainwater harvesting to conserve water.</li>
      </ul>

      <h3>4. Why Choose Eco Farming?</h3>
      <p>Choosing eco farming helps ensure a healthier planet, better food security, and a sustainable future. It is a choice that benefits both farmers and consumers. By supporting eco-friendly practices, we are contributing to a more sustainable world and ensuring the preservation of natural resources for future generations.</p>

      <h3>5. AHH International's Commitment to Eco Farming</h3>
      <p>At **AHH International**, we are dedicated to promoting eco-friendly farming practices. Our products are sourced from farms that prioritize sustainability, ethical practices, and the health of the environment. We believe in the long-term benefits of eco farming and are committed to offering the best, environmentally-friendly products to our customers.</p>

      <h3>6. Get Involved</h3>
      <p>Want to learn more about eco farming or get involved in promoting sustainability? You can start by supporting eco-friendly brands, reducing waste, and spreading awareness about the importance of sustainable farming.</p>

      <h3>7. Contact Us</h3>
      <p>If you want to know more about our eco-friendly farming practices, feel free to contact us:</p>
      <p>📧 Email: support@ahhinternational.com</p>
      <p>📞 Phone: +92 300 1234567</p>
      <p>📍 Address: Head Office, Kamirwala, Pakistan</p>
    </div>
    </div>
  )
}

export default EcoFarming
